type Props = { suspense?: boolean };

export default function PerfSuspense({ suspense }: Props) {
  if (suspense) {
    throw new Promise(() => undefined);
  } else {
    return null;
  }
}
